import * as React from 'react'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import { animationStore } from '../../../../stores'
import { cartStore } from '../../../cart'
import { getFeatureFlag } from '../../../../utils'
import './checkout-proceed-button.scss'

interface IProps {
  onClick: () => void
  hasUnavailableItems?: boolean
  text: string
  gtmId: string
  disabled?: boolean
}

const baseClass: string = 'checkout-proceed-button'

export const CheckoutProceedButton = observer((props: IProps): React.ReactElement => {
  const { onClick, text, gtmId, hasUnavailableItems, disabled: propDisabled } = props
  
  const isMaintenanceModeEnabled = getFeatureFlag('isMaintenanceModeEnabled')
  const disabled = !cartStore.minimumDollarAmountHasBeenMet || cartStore.isSubmitting || propDisabled || isMaintenanceModeEnabled

  const buttonProps: object = {
    'data-gtm-id': gtmId,
    className: classNames({
      [baseClass]: true,
      [`${baseClass}--disabled`]: disabled
    }),
    ...(!disabled ? { onClick } : {})
  }

  return (
    <div className={`${baseClass}__wrapper`}>
      {hasUnavailableItems && (
        <div className={`${baseClass}__unavailable-items`}>
          <p>Some items in your cart are not available for delivery on the date you have chosen.</p>
        </div>
      )}
      <button {...buttonProps}>
        <div className='flex items--center justify--center'>
          <div
            className={classNames({
              [`${baseClass}__orders`]: true,
              ['pulse--dark-green']: animationStore.isAnimating(cartStore.pulseAnimationKey)
            })}
          >
            {cartStore.productAmount}
          </div>
          <div className={`${baseClass}__total`}>
            <p>Total: ${cartStore.dollarAmount.toFixed(2)}</p>
          </div>
        </div>
        <div className={`${baseClass}__action`}>
          {cartStore.isSubmitting ? (
            <>
              Processing...
              <i className='icon-diy' />
            </>
          ) : (
            <>
              {text}
              <i className='icon-arrow-right-thin' />
            </>
          )}
        </div>
      </button>
    </div>
  )
})
